<template>
  <section class="p-0 m-0 aboutsection">
    <b-container class="py-5 text-left">
      <b-row class="py-1">
        <b-col class="px-5 py-3">
          <h2>Committed to quality. Passionate about service.</h2>
          <p>Impact Imaging Group is the vision of Tony Prozzi and Gary Campbell, long time friends and colleagues
            in the prepress industry. When they surveyed the corrugated graphics and prepress market in 2018 it looked
            a lot like the market of the 90’s, with little to no technological innovation or investment. They decided to
            open a new prepress company and invest in state-of-the-art equipment that would allow them to produce higher
            quality printing plates while offering better turnaround times and more accuracy.</p>
        </b-col>
      </b-row>
      <b-row class="d-flex py-1" v-for="(item, index) in items" :key="item.heading">
        <b-col cols="12" lg="6" order="2" :order-lg="ordering(index)" class="d-flex align-items-center justify-content-center px-5 py-3">
          <div>
            <h5>{{item.heading}}</h5>
            <p v-for="p in item.content" :key="p">{{p}}</p>
          </div>
        </b-col>
        <b-col cols="12" lg="6" order="1" :order-lg="ordering(index+1)" class="d-flex align-items-start py-3 px-5 justify-content-center">
          <b-img-lazy v-bind="mainProps" :src="require(`@/assets/about/${item.image}`)" rounded="true" fluid  class="py-3"></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      mainProps: {
        blank: true,
        blankColor: '#777',
      },
      items: [
        {
          heading: "Powered by our team.",
          content: [
              "Since the opening week, Impact has grown quickly, thanks to our team of dedicated and passionate" +
              " employees. We are committed to delivering the finest services in the flexible packaging industry, and with" +
              " over 200+ years of combined experience, we exceed our customers’ expectations every time. Our customer-first" +
              " successes are measured by their satisfaction with the final product. Our commitment is to help make you better.",
          ],
          image: "review.jpg"
        },
        {
          heading: "Partners, not customers.",
          content: [
              "Our founding principles are centered around the concept that good partners are better together." +
              " We focus on building a symbiotic relationship that our customers can rely on, one that allows us to" +
              " learn and grow together to become better in business through a collective gain in knowledge." +
              " This partnership principle and the pride taken in what and how we do our work is what sets us apart." +
              " We want our partners to be better now than before they met the Impact Imaging Group. We are available" +
              " to provide advice, technical support and even training, as well as quality printing plates.",
              "Partnering with companies who demand the best is what drives us to be our best. And working closely with our" +
              " partners and being able to see each project from their perspective means that we deliver plates today that" +
              " we will confidently stand behind tomorrow.",
          ],
          image: "partnership.jpg"
        },
      ]
    }
  },
  methods: {
    ordering(num) {
      if (num % 2 == 0) {
        return 1;
      }
      return 2;
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';

.aboutsection {
  background-color: $gray-200;
  border-top: 3px solid $primary;
}

.staggered-content {
  display: flex;
  flex-direction: row;
}

</style>